import type { AnnotationType } from '@/core/annotationTypes'

export const maskAnnotationType: AnnotationType = 'mask'
export const polygonAnnotationType: AnnotationType = 'polygon'
